import { RecordType } from '@petconsole/pure-base';
import { petTrainerApiEntity } from '@petconsole/pure-fe-api';
import { PetTrainerRecord } from '@petconsole/pure-shared';
import { sliceHookTypes } from '../../../helpers';
import {
  BaseSliceOptions,
  BaseSliceTab,
  CitySearchHooks,
  OurEntityHooks,
  RatingHooks,
  RequiredCrudSliverHooks,
  RequiredSliverHooks,
  TabValueHooks,
} from '../../../types';
import BaseEntitySlice from '../../base/BaseEntitySlice';

type ApiEntityRecord = PetTrainerRecord;

const apiEntity = petTrainerApiEntity;
const { name: sliceName, plural } = apiEntity;
const petTrainer = sliceName;
const petTrainers = plural;
const petTrainerAdmin = `${sliceName}Admin`;

const Tab = { petTrainerAdmin, petTrainer, petTrainers } as const;
type Tabs = { [key in keyof typeof Tab]: BaseSliceTab };
type TabHooks = { [key in keyof typeof Tab]: TabValueHooks };
const tabs: Tabs = {
  petTrainerAdmin: { default: '' },
  petTrainer: { default: '' },
  petTrainers: { default: '' },
};

const options: BaseSliceOptions<ApiEntityRecord> = {
  ...apiEntity,
  hasCitySliver: true,
  hasNewestSliver: true,
  hasCitySearch: true,
  hasDefaultProperties: true,
  hasRating: true,
  tabs,
};
const { hooks, reducer } = new BaseEntitySlice<ApiEntityRecord>({ options });
const { crudHooks, sliverHooks, propertyHooks, citySearchHooks, ratingHooks, tabHooks } = sliceHookTypes;

export interface OurPetTrainerHooks<T extends RecordType = ApiEntityRecord> extends OurEntityHooks<T> {
  petTrainerHooks: RequiredCrudSliverHooks;
  cityPetTrainerHooks: RequiredSliverHooks;
  newestPetTrainerHooks: RequiredSliverHooks;
  propertyHooks: RecordType;
  citySearchHooks: CitySearchHooks;
  ratingHooks: RatingHooks;
  tabHooks: TabHooks;
}

export const ourPetTrainerHooks: OurPetTrainerHooks = {
  entity: apiEntity,
  petTrainerHooks: crudHooks(apiEntity, hooks) as RequiredCrudSliverHooks,
  cityPetTrainerHooks: sliverHooks(apiEntity, 'City', hooks) as RequiredSliverHooks,
  newestPetTrainerHooks: sliverHooks(apiEntity, 'Newest', hooks) as RequiredSliverHooks,
  citySearchHooks: citySearchHooks(apiEntity, hooks),
  propertyHooks: propertyHooks(apiEntity, hooks),
  ratingHooks: ratingHooks(apiEntity, hooks),
  tabHooks: <TabHooks>tabHooks(Object.keys(Tab), hooks),
};

export default reducer;
